(() => {
  const normalize = (value) => (value || '').trim().toLocaleLowerCase('de-DE');

  const initProduct = (root) => {
    if (!root || root.dataset.pictProductReady === 'true') return;
    root.dataset.pictProductReady = 'true';

    const kit = root.querySelector('[data-pict-product-kit]');
    const frameTile = root.querySelector('[data-pict-frame-tile]');
    const sticky = root.querySelector('[data-pict-sticky-buy]');
    const stickyPrice = sticky?.querySelector('[data-pict-sticky-price]');
    const stickyButton = sticky?.querySelector('[data-pict-sticky-submit]');
    const buybar = root.querySelector('.pict-product-buybar');

    const isWithFrame = () => {
      const selectedFrameChoice = root.querySelector('[data-pict-frame-choice]:checked');
      return selectedFrameChoice
        ? normalize(selectedFrameChoice.value) === normalize(root.dataset.pictFramedValue)
        : !frameTile?.hidden;
    };

    const syncFrameMedia = () => {
      const withFrame = isWithFrame();
      const gallery = root.querySelector('media-gallery');
      const modal = document.getElementById(`ProductModal-${root.dataset.section}`);
      const frameMedia = [...new Set([
        ...root.querySelectorAll('[data-pict-frame-media]'),
        ...(modal ? modal.querySelectorAll('[data-pict-frame-media]') : []),
      ])];

      frameMedia.forEach((media) => {
        media.hidden = !withFrame;
        media.setAttribute('aria-hidden', String(!withFrame));
        media.querySelector('button')?.setAttribute('tabindex', withFrame ? '0' : '-1');
      });

      if (withFrame || !gallery) return;

      const activeMedia = gallery.querySelector('.product__media-item.is-active');
      if (activeMedia && !activeMedia.matches('[data-pict-frame-media]')) return;

      const defaultMedia = gallery.querySelector('.product__media-item:not([data-pict-frame-media])');
      if (defaultMedia?.dataset.mediaId) gallery.setActiveMedia?.(defaultMedia.dataset.mediaId, true);
    };

    const syncFrameState = () => {
      if (!kit || !frameTile) return;

      const withFrame = isWithFrame();

      frameTile.hidden = !withFrame;
      kit.classList.toggle('pict-product-kit--with-frame', withFrame);
      syncFrameMedia();
    };

    const syncSticky = () => {
      if (!sticky) return;

      const sourcePrice = buybar?.querySelector('[id^="price-"]');
      const sourceButton = buybar?.querySelector('[id^="ProductSubmitButton-"]');

      if (sourcePrice && stickyPrice) stickyPrice.innerHTML = sourcePrice.innerHTML;
      if (sourceButton && stickyButton) {
        const busy = sourceButton.classList.contains('loading') || sourceButton.getAttribute('aria-disabled') === 'true';
        stickyButton.disabled = sourceButton.disabled || busy;
        stickyButton.setAttribute('aria-disabled', String(sourceButton.disabled || busy));
        stickyButton.classList.toggle('is-loading', busy);
        stickyButton.textContent = sourceButton.querySelector('span')?.textContent?.trim() || sourceButton.textContent.trim();
      }
    };

    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-pict-frame-choice]')) return;
      syncFrameState();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event?.data?.sectionId) !== String(root.dataset.section)) return;
        syncFrameState();
        syncSticky();
      });
    }

    stickyButton?.addEventListener('click', () => {
      const sourceButton = buybar?.querySelector('[id^="ProductSubmitButton-"]');
      if (sourceButton && !sourceButton.disabled) sourceButton.click();
    });

    if (sticky && buybar && 'IntersectionObserver' in window) {
      const observer = new window.IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.15 });
      observer.observe(buybar);
    } else if (sticky) {
      sticky.classList.add('is-visible');
    }

    if (buybar && 'MutationObserver' in window) {
      const observer = new window.MutationObserver(syncSticky);
      observer.observe(buybar, { attributes: true, childList: true, subtree: true });
    }

    syncFrameState();
    syncSticky();
  };

  const initAllProducts = (scope = document) => {
    if (scope.matches?.('[data-pict-product]')) initProduct(scope);
    scope.querySelectorAll?.('[data-pict-product]').forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProducts(), { once: true });
  } else {
    initAllProducts();
  }

  document.addEventListener('product-info:loaded', (event) => initAllProducts(event.target));
  document.addEventListener('shopify:section:load', (event) => initAllProducts(event.target));
})();
